import { Injectable } from '@angular/core';
import { UserLogService } from '../user-log.service';
import { TokenStorageService } from '../token-storage.service';

@Injectable({
    providedIn: 'root'
})

export class UtilLogService {
    constructor(
        private userLogService: UserLogService,
        private tokenStorage: TokenStorageService
    ) { }

    createLog(data: any, action: string, component: string) {
       /*  console.log("Tenemos el data en el log :  ", data, action, component); */
        
        const id = data.idtier3 || data.idnews || data.id;        
        const logData = {
            iduser: this.tokenStorage.getUser().id,
            nameUser: this.tokenStorage.getUser().nombre,
            idContent: data.id,
            nameComponent: component,
            idtier3: id,
            action: action
        };
        this.userLogService.createUserLog(logData).subscribe({
            error: err => console.error('Error al crear el log: ', err)
        });
    }

}
